import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { COMPANY } from "@/data/site";

const AdminLogin = () => {
  const { user, ready, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (ready && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Signed in.");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid email or password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center bg-crest-surface px-4" data-testid="admin-login-page">
      <form onSubmit={onSubmit} className="w-full max-w-md rounded-lg bg-white border border-border p-8 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 grid place-items-center rounded-md bg-crest-green text-white">
            <Lock className="h-5 w-5" />
          </div>
          <div>
            <h1 className="font-display text-xl font-bold text-crest-navy">Staff sign in</h1>
            <p className="text-xs text-muted-foreground">Cresttor admin · gallery management</p>
          </div>
        </div>
        <hr className="gold-rule mt-5" />
        <div className="mt-6 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-[0.14em] text-crest-navy/70 font-medium">Email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-11" required data-testid="admin-email" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.14em] text-crest-navy/70 font-medium">Password</label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 h-11" required data-testid="admin-password" />
          </div>
        </div>
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-md bg-crest-green px-5 py-3 text-sm font-semibold text-white hover:bg-crest-green-700 transition-colors duration-200 disabled:opacity-60"
        >
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}
          Sign in
        </button>
        <Link to="/" className="mt-5 block text-center text-xs text-muted-foreground hover:text-crest-green" data-testid="admin-back-link">
          ← Back to {COMPANY.name}
        </Link>
      </form>
    </div>
  );
};

export default AdminLogin;
